import React from 'react';
import ProductPageTemplate from './ProductPageTemplate';
import {
  CustomsIcon,
  AutomatedCustomTracker,
  CreateShipmentUsingSBBE,
  CustomAnalyticsDashboard,
} from '../../assets';

const CustomsPageUS = () => {
  const productData = {
    productName: 'Customs',
    tagline: 'US Customs Documentation and Compliance Management',
    metaDescription:
      'US customs documentation module for freight forwarders and NVOCCs: manage import/export document packages, track filing status, and prepare AMS and ISF manifests. AMS/ISF direct filing on the 2026 roadmap.',
    description:
      'Manage US customs documentation workflows in Shipmnts today: complete import and export document packages, manifest preparation, shipment-level status tracking, and analytics. Direct AMS/ISF electronic filing via ACE is coming in 2026.',
    icon: CustomsIcon,
    pageUrlOverride: 'https://shipmnts.com/us/products/customs',
    currency: 'USD',
    features: [
      {
        title: 'Import and Export Document Management',
        description:
          'Manage complete US import and export document packages: commercial invoices, packing lists, ocean BL, AWB, ISF worksheets, and entry summaries: organized per shipment in a single workspace.',
        image: AutomatedCustomTracker,
      },
      {
        title: 'AMS/ISF Manifest Preparation',
        description:
          'Build and track AMS and ISF 10+2 data packages from shipment records. Prepare manifests for submission to your customs broker or AMS filer: structured data ready for ACE filing.',
        image: CreateShipmentUsingSBBE,
      },
      {
        title: 'Customs Operations Analytics',
        description:
          'Track entry status, document completeness, clearance timelines, and duty estimates across your US import and export portfolio: with USD-native branch-wise reporting.',
        image: CustomAnalyticsDashboard,
      },
    ],
    faqs: [
      {
        question: 'Does Shipmnts support AMS and ISF 10+2 filing for US imports?',
        answer:
          'Not yet. Direct AMS (Automated Manifest System) and ISF 10+2 filing via ACE (Automated Commercial Environment) is on the Shipmnts roadmap for 2026. Today, Shipmnts manages AMS and ISF data within shipment records and generates structured data packages ready for submission to your AMS filer or customs broker.',
      },
      {
        question: 'What US customs workflows does Shipmnts support today?',
        answer:
          'Shipmnts today supports complete US import and export document management: commercial invoices, packing lists, ocean BL, AWB, ISF worksheets, entry summaries, and other customs documents organized per shipment. AMS and ISF manifest data is prepared and tracked within the platform, ready for submission to a licensed AMS filer.',
      },
      {
        question: 'Does Shipmnts support AES (Automated Export System) / EEI filing?',
        answer:
          'Direct AES/EEI filing via ACE is on the Shipmnts roadmap alongside AMS/ISF for 2026. Today, Shipmnts manages export documentation including SLI (Shipper Letter of Instruction), export commercial invoices, and packing lists.',
      },
      {
        question: 'Is Shipmnts suitable for US NVOCCs managing FMC-regulated operations?',
        answer:
          'Yes. Shipmnts supports US NVOCC operations with House and Master Bill of Lading workflows, multi-party billing (agent and shipper), and integrated finance. FMC tariff filing is managed outside the platform: Shipmnts focuses on operational documentation and financial management.',
      },
      {
        question: 'When will direct AMS/ISF filing be available in Shipmnts?',
        answer:
          'Direct AMS and ISF 10+2 filing via ACE is targeted for 2026. US freight forwarders using Shipmnts today manage the data preparation workflow within the platform and use a licensed customs broker or standalone AMS filer for electronic submission.',
      },
      {
        question: 'Does Shipmnts support C-TPAT and ACE single window documentation?',
        answer:
          'Shipmnts manages C-TPAT-related trade partner documentation (certificates, authorizations, supplier records) within shipment and partner records. ACE single window integration is part of the broader 2026 US customs roadmap.',
      },
    ],
  };

  return <ProductPageTemplate {...productData} />;
};

export default CustomsPageUS;
